import { gql } from '@apollo/client';
import {
  TicketAffiliateLinkFields,
  TicketEventDetailsFields,
  TicketingSettingFields,
  TicketMatchupFields,
  TicketPresaleCodeFields,
  TicketTierFields,
  TicketVenueFields,
} from './fragments';

export const SET_TICKETING_SETTING = gql`
  mutation SetTicketingSetting($input: SetTicketingSettingInput!) {
    setTicketingSetting(input: $input) {
      ...TicketingSettingFields
    }
  }
  ${TicketingSettingFields}
`;

export const CREATE_TICKET_EVENT = gql`
  mutation CreateTicketEvent($input: CreateTicketEventInput!) {
    createTicketEvent(input: $input) {
      ...TicketEventDetailsFields
    }
  }
  ${TicketEventDetailsFields}
`;

export const UPDATE_TICKET_EVENT_DETAILS = gql`
  mutation UpdateTicketEventDetails($input: UpdateTicketEventDetailsInput!) {
    updateTicketEventDetails(input: $input) {
      ...TicketEventDetailsFields
    }
  }
  ${TicketEventDetailsFields}
`;

export const RESCHEDULE_TICKET_EVENT = gql`
  mutation RescheduleTicketEvent($input: RescheduleTicketEventInput!) {
    rescheduleTicketEvent(input: $input) {
      ...TicketEventDetailsFields
    }
  }
  ${TicketEventDetailsFields}
`;

export const SET_TICKET_SALE_STATUS = gql`
  mutation SetTicketSaleStatus($input: SetTicketSaleStatusInput!) {
    setTicketSaleStatus(input: $input) {
      ...TicketEventDetailsFields
    }
  }
  ${TicketEventDetailsFields}
`;

export const APPROVE_TICKET_ZERO_TAX = gql`
  mutation ApproveTicketZeroTax($input: ApproveTicketZeroTaxInput!) {
    approveTicketZeroTax(input: $input) {
      ...TicketEventDetailsFields
    }
  }
  ${TicketEventDetailsFields}
`;

export const ADD_TICKET_TIER = gql`
  mutation AddTicketTier($input: AddTicketTierInput!) {
    addTicketTier(input: $input) {
      ...TicketTierFields
    }
  }
  ${TicketTierFields}
`;

export const CREATE_TICKET_VENUE = gql`
  mutation CreateTicketVenue($input: CreateTicketVenueInput!) {
    createTicketVenue(input: $input) {
      ...TicketVenueFields
    }
  }
  ${TicketVenueFields}
`;

export const CREATE_TICKET_EVENT_IMAGE_UPLOAD_URLS = gql`
  mutation CreateTicketEventImageUploadUrls(
    $input: TicketEventImageUploadInput!
  ) {
    createTicketEventImageUploadUrls(input: $input) {
      url
      fields
      key
    }
  }
`;

export const REFUND_TICKET_ORDER = gql`
  mutation RefundTicketOrder($input: RefundTicketOrderInput!) {
    refundTicketOrder(input: $input) {
      id
    }
  }
`;

export const REFUND_CANCELLED_TICKET_EVENT_ORDERS = gql`
  mutation RefundCancelledTicketEventOrders(
    $input: RefundTicketEventOrdersInput!
  ) {
    refundCancelledTicketEventOrders(input: $input) {
      ticketEventId
      refundableOrders
    }
  }
`;

export const ISSUE_COMP_TICKETS = gql`
  mutation IssueCompTickets($input: IssueCompTicketsInput!) {
    issueCompTickets(input: $input) {
      id
      reference
    }
  }
`;

export const REVOKE_COMP_TICKET_ORDER = gql`
  mutation RevokeCompTicketOrder($input: RevokeCompTicketOrderInput!) {
    revokeCompTicketOrder(input: $input) {
      id
    }
  }
`;

export const CREATE_TICKET_PRESALE_CODE = gql`
  mutation CreateTicketPresaleCode($input: CreateTicketPresaleCodeInput!) {
    createTicketPresaleCode(input: $input) {
      ...TicketPresaleCodeFields
    }
  }
  ${TicketPresaleCodeFields}
`;

export const SET_TICKET_PRESALE_CODE_ACTIVE = gql`
  mutation SetTicketPresaleCodeActive(
    $input: SetTicketPresaleCodeActiveInput!
  ) {
    setTicketPresaleCodeActive(input: $input) {
      id
      active
    }
  }
`;

export const ADD_TICKET_EVENT_AFFILIATE = gql`
  mutation AddTicketEventAffiliate($input: AddStreamAffiliateInput!) {
    addStreamAffiliate(input: $input) {
      ...TicketAffiliateLinkFields
    }
  }
  ${TicketAffiliateLinkFields}
`;

export const SET_TICKET_EVENT_AFFILIATE_STATUS = gql`
  mutation SetTicketEventAffiliateStatus(
    $input: SetStreamAffiliateLinkStatusInput!
  ) {
    setStreamAffiliateLinkStatus(input: $input) {
      ...TicketAffiliateLinkFields
    }
  }
  ${TicketAffiliateLinkFields}
`;

export const SET_TICKET_EVENT_AFFILIATE_COMMISSION = gql`
  mutation SetTicketEventAffiliateCommission(
    $input: SetStreamAffiliateLinkCommissionInput!
  ) {
    setStreamAffiliateLinkCommission(input: $input) {
      ...TicketAffiliateLinkFields
    }
  }
  ${TicketAffiliateLinkFields}
`;

export const REGENERATE_TICKET_EVENT_AFFILIATE_LINK = gql`
  mutation RegenerateTicketEventAffiliateLink(
    $input: RegenerateStreamAffiliateLinkInput!
  ) {
    regenerateStreamAffiliateLink(input: $input) {
      ...TicketAffiliateLinkFields
    }
  }
  ${TicketAffiliateLinkFields}
`;

export const REMOVE_TICKET_EVENT_PARTICIPANT = gql`
  mutation RemoveTicketEventParticipant(
    $input: RemoveTicketEventParticipantInput!
  ) {
    removeTicketEventParticipant(input: $input)
  }
`;

export const SET_TICKET_EVENT_MATCHUPS = gql`
  mutation SetTicketEventMatchups($input: SetTicketEventMatchupsInput!) {
    setTicketEventMatchups(input: $input) {
      ...TicketMatchupFields
    }
  }
  ${TicketMatchupFields}
`;

export const DECLARE_TICKET_EVENT_MATCHUP_WINNER = gql`
  mutation DeclareTicketEventMatchupWinner(
    $input: DeclareTicketEventMatchupWinnerInput!
  ) {
    declareTicketEventMatchupWinner(input: $input) {
      ...TicketMatchupFields
    }
  }
  ${TicketMatchupFields}
`;
